export const filterDistanceCreateDataJson = (jsonData) => {
    let newDataJson = {}
    const { filters, entities } = jsonData;

    if (process.env.REACT_APP_CLIENT === "gdh_mondelta") {
        const filtersBienVille = filters.town.values;

        filtersBienVille.forEach(ville => {
            const entity = entities.find(ent =>
                ent.town.includes(ville.name)
                && ent.longitude
                && ent.latitude
            );

            if (entity) {
                ville.latitude = entity.latitude;
                ville.longitude = entity.longitude;
            }
        });

        newDataJson = {
            ...jsonData,
            filters: {
                ...filters,
                town: {
                    ...filters.town,
                    values: filtersBienVille
                }
            }
        };
    }
    if (process.env.REACT_APP_CLIENT === "gdh_residences") {
        const filtersBienVille = filters.ville_residence.values;

        filtersBienVille.forEach(ville => {
            const entity = entities.find(ent =>
                ent.ville_residence.includes(ville.name)
                && ent.longitude
                && ent.latitude
            );

            if (entity) {
                ville.latitude = entity.latitude;
                ville.longitude = entity.longitude;
            }
        });

        newDataJson = {
            ...jsonData,
            filters: {
                ...filters,
                ville_residence: {
                    ...filters.ville_residence,
                    values: filtersBienVille
                }
            }
        };
    }

    return newDataJson
}